import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Tooltip({ title, children, ...props }: MuiTooltipProps) {
  const { t } = useTranslation();
  return (
    <MuiTooltip
      title={typeof title === 'string' ? t(title) : title}
      componentsProps={{
        popper: {
          sx: {
            ['& .MuiTooltip-arrow']: {
              color: '#9CDFFC',
            },
            ['& .MuiTooltip-tooltip']: {
              backgroundColor: '#9CDFFC',
              color: '#000000',
              fontSize: '14px',
              padding: '14px',
              borderRadius: '8px',
            },
          },
        },
      }}
      placement="top"
      arrow
      {...props}
    >
      {children}
    </MuiTooltip>
  );
}

export function useTooltpsForAutocomplete() {
  const [autocompleteOpenedRaw, setAutocompleteOpenedRaw] = useState<string[]>([]);

  const getProps = useCallback(
    (id: string) => ({
      id,
      clearText: '',
      openText: '',
      closeText: '',

      clearIcon: (
        <Tooltip title="clear">
          <ClearIcon fontSize="small" />
        </Tooltip>
      ),

      open: autocompleteOpenedRaw.includes(id),
      popupIcon: (
        <Tooltip title={autocompleteOpenedRaw.includes(id) ? 'close-list' : 'open-list'}>
          <ArrowDropDownIcon fontSize="small" />
        </Tooltip>
      ),
      onOpen: () => setAutocompleteOpenedRaw(val => [...val, id]),
      onClose: () => setAutocompleteOpenedRaw(val => val.filter(vid => vid !== id)),
    }),
    [autocompleteOpenedRaw],
  );

  return { getProps };
}
